<template>
    <v-app id="app">
        <transition name="router-anim">
            <router-view ></router-view>
        </transition>       
    </v-app>
</template>

<script>

import { PT_BR } from './utils/consts';

export default {

    name: 'App',

    beforeCreate() {

        if (localStorage.locale_forced) {

            return this.$root.$i18n.locale = localStorage.locale

        }

        if (navigator.language.includes('es')) {

            this.$root.$i18n.locale = 'es';
            return localStorage.locale = 'es';

        }

        this.$root.$i18n.locale = PT_BR;
        return localStorage.locale = PT_BR;
    },

};

</script>

<style lang='scss'>

@import url('https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap');
@import url("https://cdn.jsdelivr.net/npm/@mdi/font@latest/css/materialdesignicons.min.css");

html,
body {

    height: 100%;
    width: 100%;
    padding: 0;
    margin: 0;
    --blue-qi: #4ec5c1; // Cor dos Botões

}



#app {
    font-family: 'Montserrat', sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    -webkit-text-stroke: 0.45px rgba(0, 0, 0, 0.1);
    height: 100%;
    width: 100%
}

.v-application--wrap {
    min-height: 100px !important;
}

.align-input-center input {
    text-align: center;
}

.v-application .justify-space-evenly {
    justify-content: space-evenly !important;
}

.background-pattern {
    background: linear-gradient(180deg, rgba(255, 255, 255, 0) 2.59%, #FFEBDD 61.46%), #FAF7F2;
    box-shadow: 0 5px 6px rgba(0, 0, 0, 0.2), 0 3px 16px rgba(0, 0, 0, 0.12), 0 9px 12px rgba(0, 0, 0, 0.14);
    border-radius: 30px !important;
}

.imgHome {

    width: 200%;
    height: 200%;
}

.router-anim-enter-active {
    animation: coming .25s;
    animation-delay: .25s;
    opacity: 0;
}

.router-anim-leave-active {
    animation: going .3s;
}

@keyframes going {
    from {
        transform: translateY(0);
    }

    to {
        transform: translateY(-30px);
        opacity: 0;
    }
}

@keyframes coming {
    from {
        transform: translateY(-30px);
        opacity: 0;
    }

    to {
        transform: translateY(0);
        opacity: 1;
    }
}

@keyframes pulse-anim {
    0% {
        transform: scale(0.95);
        box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.7);
    }

    70% {
        transform: scale(1);
        box-shadow: 0 0 0 10px rgba(0, 0, 0, 0);
    }

    100% {
        transform: scale(0.95);
        box-shadow: 0 0 0 0 rgba(0, 0, 0, 0);
    }
}

@keyframes pulse-anim-alt {
    0% {
        transform: scale(1);
        box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.7);
    }

    70% {
        transform: scale(1);
        box-shadow: 0 0 0 7px rgba(0, 0, 0, 0);
    }

    100% {
        transform: scale(1);
        box-shadow: 0 0 0 0 rgba(0, 0, 0, 0);
    }
}

</style>
